module.exports = __webpack_public_path__ + "static/media/fougasse.054f01c5.JPG";